<template>
    <modal ref="modal" @hide="onHide">
        <div id="sub-wrapper">
            <div class="title">{{ $t('modals.event_files_available.title') }}</div>
            <div class="content" :class="contentClassName()">
                <div>
                    <img :src="require('@/assets/img/video_placeholder_' + orientation + '.jpg')"/>
                    <div class="background"></div>
                    <div class="text">
                        <div>{{ $t('modals.event_files_available.img_text') }}</div>
                    </div>
                    <video v-if="play_url_with_token" :src="play_url_with_token" controls @loadeddata="onLoadedData"/>
                </div>
            </div>
            <div class="link">
                <a v-if="!downloaded" target="_blank" :href="download_url_with_token" @click="onDownload">
                    <button>{{ $t('modals.event_files_available.links.download') }}</button>
                </a>
                <button v-else @click="hide">{{ $t('modals.event_files_available.links.done') }}</button>
                <div v-if="!downloaded" id="no" @click="hide">
                  <div>{{ $t('modals.event_files_available.links.no') }}</div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import auth from '@/services/auth'

export default {
  data () {
    return {
      download_url: null,
      download_url_with_token: null,
      downloaded: false,
      orientation: 'landscape',
      play_url: null,
      play_url_with_token: null,
      slidedDownload: false,
      videoLoading: true
    }
  },
  methods: {
    show (downloadUrl, playUrl, orientation) {
      this.download_url = downloadUrl
      this.download_url_with_token = null
      this.downloaded = false
      this.orientation = orientation
      this.play_url = playUrl
      this.play_url_with_token = null
      this.updateRecording(this.$refs.modal.show)
    },
    showing () {
      return this.$refs.modal.showing()
    },
    hide () {
      this.$refs.modal.hide()
    },
    updateRecording (fn) {
      // Create counter
      var cnt = 0

      // Update download url
      auth.urlWithAccessToken(this.download_url).then(function (url) {
        // Update url
        this.download_url_with_token = url

        // Increment counter
        cnt++

        // Custom
        if (cnt === 2) fn()
      }.bind(this))

      // Update play url
      auth.urlWithAccessToken(this.play_url).then(function (url) {
        // Update url
        this.play_url_with_token = url

        // Increment counter
        cnt++

        // Custom
        if (cnt === 2) fn()
      }.bind(this))
    },
    onLoadedData () {
      this.videoLoading = false
    },
    contentClassName () {
      return (this.videoLoading ? '' : 'video-loaded')
    },
    onHide () {
      // Reset
      this.download_url_with_token = null
      this.play_url_with_token = null
      this.videoLoading = true

      // Propagate event
      this.$emit('hide')
    },
    onDownload () {
      this.downloaded = true
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 32em;
}

#sub-wrapper .title {
  margin-bottom: 1em;
}

#sub-wrapper .content {
  display: flex;
  height: 18em; /* = 32em * 9 / 16 */
  width: 100%;
}

#sub-wrapper .content > div {
  height: 100%;
  margin: auto;
  position: relative;
}

#sub-wrapper .content > div  > img {
  height: 100%;
}

#sub-wrapper .content > div  > div {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

#sub-wrapper .content .background {
  background-color: #000000;
  opacity: 0.7;
}

#sub-wrapper .content .text {
  align-content: center;
  color: #ffffff;
  display: flex;
  justify-items: center;
}

#sub-wrapper .content .text > div {
  margin: auto;
  padding: 1em;
}

#sub-wrapper .text {
  display: flex;
  flex-grow: 1;
  margin: auto;
  width: 90%;
}

#sub-wrapper .text > div {
  margin: auto;
}

#sub-wrapper .content video {
  display: none;
  height: 100%;
  left: 0;
  margin: auto;
  position: absolute;
  top: 0;
  width: 100%;
}

#sub-wrapper .content.video-loaded video {
  display: block;
}

#sub-wrapper .link {
  margin-top: 2em;
}

#sub-wrapper .link #no {
  cursor: pointer;
  display: flex;
  height: 2em;
}

#sub-wrapper .link #no:hover {
  text-decoration: underline;
}

#sub-wrapper .link #no > div {
  margin: auto auto 0 auto;
}

</style>
